export default "__VITE_ASSET__CIb_NUnP__"